export const enTenants = {
  title: "Tenants",
  subtitle: "View all tenants in the Olive platform.",
  empty: "No tenants found.",
  actions: {
    newTenant: "Add Tenant",
    clearAllCache: "Clear All Tenants' Cache",
  },
  newTenantModal: {
    title: "Add Tenant",
    closeAria: "Close dialog",
    fields: {
      tenantName: "Tenant name",
    },
    validation: {
      required: "This field is required.",
      invalidFormat:
        "Use lowercase letters, numbers, and hyphens (1–63 characters; no leading or trailing hyphen).",
    },
    actions: {
      cancel: "Cancel",
      save: "Save",
    },
    errors: {
      saveFailed: "Failed to add tenant. Please try again.",
    },
  },
  table: {
    name: "Name",
    status: "Status",
    created: "Created",
    cacheInterval: "Cache Clears Every",
    cacheIntervalValue_one: "{{count}} hour (UTC)",
    cacheIntervalValue_other: "{{count}} hours (UTC)",
    actions: "Actions",
    ariaLabel: "Tenants",
    clearCacheAria: "Clear cache for {{name}}",
    editCacheIntervalAria: "Edit cache clear interval for {{name}}",
    editCacheIntervalTooltip: "Edit Cache clear interval",
  },
  cacheIntervalModal: {
    title: "Query Cache Clear Interval",
    closeAria: "Close dialog",
    description:
      "How often {{name}}'s query cache is cleared. Clears happen on fixed UTC boundaries — a 12-hour interval clears at 12:00 AM and 12:00 PM UTC.",
    fields: {
      intervalHours: "Clear interval",
      intervalHelper: "Between 1 and 24 hours.",
      intervalOption_one: "Every {{count}} hour",
      intervalOption_other: "Every {{count}} hours",
    },
    actions: {
      cancel: "Cancel",
      save: "Save",
    },
    success: "Cache clear interval updated.",
    errors: {
      saveFailed: "Failed to update the cache clear interval. Please try again.",
    },
  },
  status: {
    pending: "Pending",
    provisioning: "Provisioning",
    active: "Active",
    failed: "Failed",
  },
  clearCacheDialog: {
    heading: "Clear cache for this tenant?",
    subheading:
      "This removes all cached API responses and cached query results for this tenant. Users may see a brief slowdown while the cache repopulates.",
    cancel: "Cancel",
    confirm: "Clear Cache",
    success: "Cache cleared for this tenant.",
    errors: {
      clearFailed: "Failed to clear cache. Please try again.",
    },
  },
  clearAllCacheDialog: {
    heading: "Clear cache for all tenants?",
    subheading:
      "This clears cached responses and cached query results for every tenant on the platform and cannot be undone. This is a heavier operation — use only when necessary.",
    cancel: "Cancel",
    confirm: "Clear All",
    success: "Cache cleared for all tenants.",
    errors: {
      clearFailed: "Failed to clear cache. Please try again.",
    },
  },
} as const;
